import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Pagination from 'react-js-pagination';

import * as featuredActions from './FeaturedActions';
import ListingComponent from '../listings/ListingsComponent';
import AgentComponent from '../agent/AgentComponent';
// import PaginationComponent from './pagination/PaginationComponent';
import './Style';


class FeaturedContainer extends Component {
    constructor(props) {
        super(props);

         this.state = {
            agentType: 'agent',
            activePage: 1,
            error: null,
            errorInfo: null
        }

        this.pageLinkClick = this.pageLinkClick.bind(this);
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error,
            errorInfo
        }, () => {
            console.error(error, errorInfo);
        });
    }

    pageLinkClick(page) {
        const { agentId, listingPerPage } = this.props;

        let startFrom = page * listingPerPage - listingPerPage;
        this.setState({'activePage' : page})
        this.props.featuredActions.getFeaturedPagination(agentId, listingPerPage, startFrom);
    }

    render() {
        const { agentId, agentInfo, listingsList, listingPerPage, listingsCount, imageSizeParams } = this.props;
        const { agentType, activePage } = this.state;

        const listingsBlocks = listingsList.map((listing, i) => {
            return <ListingComponent key={i} listingData={listing}  imageSizeParams={imageSizeParams}/>
        });

        const agentBlock = agentInfo.name
            ? (
                <div className="featured-agent-container">
                    <AgentComponent
                        agentInfo={agentInfo}
                        agentType={agentType}
                        contactAgent={null}
                        openContactFullscreen={null}
                    />
                </div>
            )
            : null;

        return (
            <div className="featured-container">
                {agentBlock}
                <div className="listing-container" id="listings">
                    <h2 className="section-header">featured listings</h2>
                    <div className="listings-list">
                        {listingsBlocks}
                    </div>
                </div>
                <div className="pagination-container">
                    {listingsCount > 10 && <Pagination
                        activePage={activePage}
                        itemsCountPerPage={10}
                        totalItemsCount={listingsCount}
                        pageRangeDisplayed={5}
                        onChange={this.pageLinkClick}
                        innerClass="pagination"
                        itemClass="page-link"
                        activeClass="active"
                        disabledClass="disabled"
                    />}
                </div>
            </div>
        );
    }
}

FeaturedContainer.propTypes = {
    agentId: PropTypes.number.isRequired,
    listingsList: PropTypes.array.isRequired,
    listingPerPage: PropTypes.number.isRequired
};

const mapStateToProps = (state) => {
    return {
       agentId: state.featured.agentId,
       agentInfo: state.featured.agentInfo,
       listingsList: state.featured.listingsList,
       listingPerPage: state.featured.listingPerPage,
       listingsCount: state.featured.listingsCount,
       imageSizeParams: state.gallery.imageSizeParams,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        featuredActions: bindActionCreators(featuredActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FeaturedContainer)
